import {
  Button,
  CircularProgress,
  Dialog
} from '@material-ui/core';
import ModalCloseButton from 'components/modal-close-button';
import React from 'react';
import './admin-dialog.scss';

export interface AdminDialogProps {
  open: boolean;
  title: string;
  closeDisabled?: boolean;
  labelYes?: string;
  labelAdmin?: string;
  labelNo?: string;
  isLoading?: boolean;
  iconNo?: React.ReactNode;
  iconAdmin?: React.ReactNode;
  iconYes?: React.ReactNode;
  colorNo?: 'primary' | 'secondary' | 'inherit' | 'default';
  colorAdmin?: 'primary' | 'secondary' | 'inherit' | 'default';
  colorYes?: 'primary' | 'secondary' | 'inherit' | 'default' | 'pay';
  variantNo?: 'contained' | 'outlined' | 'text';
  variantAdmin?: 'contained' | 'outlined' | 'text';
  variantYes?: 'contained' | 'outlined' | 'text';
  onYes?: () => void;
  onAdmin?: () => void;
  onNo: () => void;
  onClose?: () => void;
  children?: React.ReactNode;
}

export const AdminDialog: React.FC<AdminDialogProps> = ({
  open,
  title,
  closeDisabled = false,
  labelYes,
  labelAdmin,
  labelNo,
  isLoading,
  iconNo,
  iconAdmin,
  iconYes,
  colorNo,
  colorAdmin,
  colorYes,
  variantNo,
  variantAdmin,
  variantYes,
  onYes,
  onAdmin,
  onNo,
  onClose,
  children,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose || onNo}
      aria-labelledby='dialog-title'
      fullWidth
      maxWidth='md'
      PaperProps={{
        style: {
          minWidth: '300px',
          maxWidth: '650px',
          boxSizing: 'border-box',
        },
      }}
    >
      {!closeDisabled && ( 
      <ModalCloseButton onClose={onClose || onNo} />
      )}
      <div className='admin-dialog__dialog'>
        <h1>{title}</h1>
        <div className='admin-dialog__dialog-content'>
          {children}
        </div>
        <div className='admin-dialog__dialog-actions'>
          {labelNo && (
            <Button
              onClick={onNo}
              variant={variantNo}
              color={colorNo}
              startIcon={iconNo}
            >
              {labelNo}
            </Button>
          )}
          {labelAdmin && (
            <Button
              color={colorAdmin}
              onClick={onAdmin}
              variant={variantAdmin}
              className='admin'
              disabled={isLoading}
              startIcon={iconAdmin}
            >
              {labelAdmin}
            </Button>
          )}
          {labelYes && (
            <Button
              color={colorYes !== 'pay' ? colorYes : undefined}
              className={colorYes}
              variant={variantYes}
              onClick={onYes}
              disabled={isLoading}
              autoFocus
              startIcon={isLoading ? <CircularProgress color='inherit' size={20} /> : iconYes}
            >
              {isLoading ? 'Loading...' : labelYes}
            </Button>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default AdminDialog;
